export enum IntegrationDisabledButtonEnum {
  DELIVERECT = "design_system.atom_integration_disabled_button.disabled_message",
  INTEGRATION = "design_system.atom_integration_disabled_button.disabled_message_integration",
}
